/* eslint-disable import/prefer-default-export */
import * as yup from "yup";
import { addressFieldsetSchema } from "components/Shared/Forms/AddressFieldset";
import * as phoneNumberSchemaFields from "utils/schemas/phoneNumber";

export const name = yup.string().trim().label("Name").ensure().default("");

export const email = yup
  .string()
  .trim()
  .label("Email")
  .ensure()
  .default("")
  .email();

export const phone = phoneNumberSchemaFields.phone.default("");

export const address = addressFieldsetSchema;
